import React from 'react';
import { Tooltip as AntTooltip, TooltipProps as AntTooltipProps } from 'antd';
import styles from './Tooltip.module.css';
import classNames from 'classnames';

export type TooltipProps = AntTooltipProps & {
  isWhite?: boolean;
};

export const Tooltip = (props: TooltipProps) => {
  const { title, children, zIndex = 1000002, isWhite, ...rest } = props;

  return (
    <AntTooltip
      overlayClassName={classNames(styles.tooltip, {
        [styles.tooltipWhite]: isWhite,
      })}
      title={title}
      zIndex={zIndex}
      {...rest}
    >
      {children}
    </AntTooltip>
  );
};
